export interface ContractDefaultUsersData {
  addressSystemId: number;
  contractStatusId: number;
  contracts: ContractInfo[];
  foremanUsers: UserInfo[];
  contractorForemanUsers: UserInfo[];
  officeUsers: UserInfo[];
}

export interface ContractInfo {
  id: number;
  name: string;
  defaultValue?: number;
}

export interface UserInfo {
  id: number;
  username: string;
  name: string;
  companyName: string;
  roleName: string;
  email: string;
  phoneNumber: string;
  contractPermissions: Record<number, UserContractPermissions>;
  defaultAssignments: Record<number, UserDefaultAssignments>;
}

export interface UserContractPermissions {
  isForeman: boolean;
  isContractorForeman: boolean;
  isOfficeUser: boolean;
}

export interface UserDefaultAssignments {
  isForeman: boolean;
  isContractorForeman: boolean;
  isOfficeUser: boolean;
}

export interface ContractDefaultUsersRequest {
  addressSystemId: number;
  contractStatusId: number;
  userAssignments: Record<number, ContractUserAssignments>;
}

export interface ContractUserAssignments {
  foremanUserId?: number;
  contractorForemanUserId?: number;
  officeUserId?: number;
}

export interface AddressSystemDropdownItem {
  id: number;
  name: string;
}

export interface ContractStatusDropdownItem {
  id: number;
  name: string;
  defaultValue?: number;
  orderInGroup?: number;
}

export enum DefaultUserRole {
  Foreman = 'foreman',
  ContractorForeman = 'contractor_foreman',
  OfficeUser = 'officeuser'
}

export const defaultUserRoleLabels = {
  [DefaultUserRole.Foreman]: 'Työnjohtaja',
  [DefaultUserRole.ContractorForeman]: 'Urakoitsijan työnjohtaja',
  [DefaultUserRole.OfficeUser]: 'Laskuttaja'
};